export default "__VITE_ASSET__B3_7T2fw__"